import {AccordionClass, AccordionInitParameters} from "./accordion";
import {DatePickerRangeClass} from "./datepickerHelper";

class BootstrapHelperClass {
	constructor() {
		if (window.BootstrapHelperClass) {
			return window.BootstrapHelperClass;
		}
		window.BootstrapHelperClass = this;

		//(document).on('document.load', ()=>this.#load());
		$(document).ready(() => this.#load());

	}

	#loadAccordions() {
		console.log("Loading accordions");
		let accordions = $("div [data-bootstrap-helper='accordion']");
		let instanceAccordions = [];
		for (let accordionItem of accordions) {
			let accordion = $(accordionItem);

			let {
				bshName: identifier,
				bshHeaderText: headerText,
				bshAccordionDefaultCollapse: defaultCollapse,
				bshAccordionCardMode: accordionCardMode,
				bshAccordionOmitCard: omitCard
			} = accordion.data();

			let originalIdentifier = identifier ?? accordion.attr("id")
			let accordionInstance = new AccordionClass(new AccordionInitParameters({
				identifier: originalIdentifier,
				headerText,
				accordionContents: accordion,
				defaultCollapse: defaultCollapse ?? "show",
				accordionCardMode,
				omitCard : omitCard ?? true
			}));

			let generatedAccordion = accordionInstance.load();
			let accordionDom = generatedAccordion.domObject[0].outerHTML;
			let finalIdentifier = originalIdentifier ?? generatedAccordion.domObject.attr("id");

			let instanceAccordion = {
				accordionInstance: generatedAccordion,
				originalIdentifier: originalIdentifier
			};
			accordion.replaceWith(accordionDom);

			instanceAccordions.push(instanceAccordion);
		}

		this.instance.accordions = instanceAccordions;
	}

	GetAccordionByIdentifier(identifier) {
		return this.instance.accordions.find((accordion) => accordion.originalIdentifier === identifier);
	}

	#load() {
		this.instance = {
			accordions: [],
			tooltips: []
		};
		
		this.#loadAccordions();

	}


	/**
	 *
	 * @type {DatePickerRangeClass[]}
	 */
	LoadedDatePickerRanges = [];
}

export const BootstrapHelper = new BootstrapHelperClass();
